// =============================================
// Team Data — Easy to add/remove members
// To add a new member:
//   1. Add their image to src/images/persons/
//   2. Import it below
//   3. Add an entry to the team array
// =============================================

import Kray from "../images/persons/kray.png";
import Koray from "../images/persons/koray.png";
import Alp from "../images/persons/alp.png";
import Orgo from "../images/persons/orgo.png";
import Ali from "../images/persons/ali.png";

// Yağmur's image — place yagmur.png in src/images/persons/
let Yagmur;
try {
  Yagmur = require("../images/persons/yagmur.png");
} catch (e) {
  Yagmur = null;
}

const team = [
  { name: "Eray Kırkpınar", role: "Game Developer", image: Kray },
  { name: "Koray Kayan", role: "Level Designer", image: Koray },
  { name: "Onur Sönmez", role: "UI Artist", image: Orgo },
  { name: "Ali Eren Gül", role: "Community Manager", image: Ali },
  { name: "Metin Alp Kocaman", role: "Marketing Manager", image: Alp },
  { name: "Yağmur", role: "3D Artist", image: Yagmur },
];

export default team;
